import type { CustomerStage } from '@proffer/shared'

export type { CustomerStage, CustomerStageBadgeTone } from '@proffer/shared'
export {
  CUSTOMER_STAGE_BADGE_TONES,
  CUSTOMER_STAGE_LABELS,
  CUSTOMER_STAGES_PIPELINE as CUSTOMER_STAGES,
  CUSTOMER_STAGES_PIPELINE,
  customerStageBadgeTone,
  customerStageBarClass,
  formatCustomerStage,
} from '@proffer/shared'

export type CustomerDto = {
  id: string
  name: string
  phone: string | null
  email: string | null
  vatNumber: string | null
  taxOffice: string | null
  address: string | null
  wantsInvoice: boolean
  referredBy: string | null
  stage: CustomerStage | string
  tags: string[]
  offersCount: number
  createdAt: string
  updatedAt: string
}

/** P4-011 — query προς GET /customers (φίλτρα + ταξινόμηση) */
export type CustomerListQuery = {
  tag?: string
  sort: 'name' | 'createdAt'
  order: 'asc' | 'desc'
}

export const DEFAULT_CUSTOMER_LIST_QUERY: CustomerListQuery = {
  sort: 'name',
  order: 'asc',
}

export function crmCustomersSwrKey(
  query: CustomerListQuery,
): readonly ['crm-customers', string] {
  return ['crm-customers', JSON.stringify(query)] as const
}

export function buildCustomersListPath(query: CustomerListQuery): string {
  const sp = new URLSearchParams()
  sp.set('sort', query.sort)
  sp.set('order', query.order)
  if (query.tag?.trim()) sp.set('tag', query.tag.trim())
  const qs = sp.toString()
  return qs ? `/customers?${qs}` : '/customers'
}
